export default __webpack_public_path__ + "static/media/feature-strategic-3.05135ca3.png";